import * as React from 'react'
import { SVGProps } from 'react'

const SvgAvatar3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 83 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M41.4 82.8c22.864 0 41.4-18.535 41.4-41.4S64.265 0 41.4 0 0 18.535 0 41.4c0 22.864 18.535 41.4 41.4 41.4Z"
      fill="#EAEAEA"
    />
    <mask
      id="avatar3_svg__a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={83}
      height={83}
    >
      <path
        d="M41.4 82.8c22.864 0 41.4-18.535 41.4-41.4S64.265 0 41.4 0 0 18.535 0 41.4c0 22.864 18.535 41.4 41.4 41.4Z"
        fill="#EAEAEA"
      />
    </mask>
    <mask
      id="avatar3_svg__b"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={83}
      height={83}
    >
      <path
        d="M41.4 82.8c22.864 0 41.4-18.535 41.4-41.4S64.265 0 41.4 0 0 18.535 0 41.4c0 22.864 18.535 41.4 41.4 41.4Z"
        fill="#EAEAEA"
      />
    </mask>
    <g mask="url(#avatar3_svg__b)">
      <path
        d="M32.822 18.887s.234-4.628 4.795-6.14c8.813-2.924 18.865 3.471 18.461 6.579 0 0 3.947 0 1.928 10.176-.99 4.993-1.513 14.453-6.856 15.362-5.344.909-11.813-4.103-11.813-4.103l-6.515-21.874Z"
        fill="#120283"
      />
      <path
        d="M33.448 18.176s-6.53-2.14-3.541 14.111c.532 2.897.782 10.414 5.936 12.086 5.154 1.671 5.356-8.724 5.356-8.724l-7.751-17.473Z"
        fill="#120283"
      />
      <path
        d="M84.653 108.318a23.345 23.345 0 0 1-1.592 2.294c-2.088 2.658-4.786 4.968-7.86 6.974a53.805 53.805 0 0 1-6.98 3.802c-8.016 3.676-17.155 5.914-24.586 7.254-8.368 1.508-14.574 1.877-14.574 1.877L9.3 120.24l-1.944-1.012L1 115.921V91.825s.188-26.524 29.019-30.234l27.046-.117s.038.015.102.033c.276.083 1.102.344 2.299.794 4.924 1.852 16.123 6.917 21.019 16.146 2.029 3.82 3.134 9.313 3.692 15.026.506 5.124.571 10.42.476 14.845Z"
        fill="#fff"
      />
      <path
        d="M57.066 61.482c-2.995 2.494-5.898 4.009-8.632 4.834h-.02c-9.016 2.7-16.2-2.14-18.997-4.484.202-.078.405-.155.604-.236a10.1 10.1 0 0 0 1.515-.76c7.125-4.37 5.828-14.484 5.828-14.484h12.653a27.064 27.064 0 0 0 .051 5.08c.422 4.178 1.966 7.864 6.998 10.05Z"
        fill="#C3C3F6"
      />
      <path
        d="M50.065 51.431c-.741 1.268-1.8 2.163-3.305 2.29-5.896.489-9.212-5.303-9.141-5.838l.304-1.533H50.01a27.074 27.074 0 0 0 .056 5.081Z"
        fill="#120283"
      />
      <path
        d="M58.005 35.278c0-1.651-1.166-2.99-2.606-2.99s-2.606 1.339-2.606 2.99c0 1.65 1.167 3.728 2.606 3.728 1.439 0 2.606-2.081 2.606-3.728Z"
        fill="#C3C3F6"
      />
      <path
        d="m54.714 36.302-.18-.02c0-.02.223-1.97 2.034-2.018v.184c-1.649.047-1.853 1.834-1.854 1.854Z"
        fill="#120283"
      />
      <path
        d="M56.5 36.025c-.307-.318-.623-.468-.936-.453-.476.028-.797.441-.801.445l-.147-.112c.016-.02.376-.483.935-.514.377-.022.734.149 1.081.514l-.132.12Z"
        fill="#120283"
      />
      <path
        d="M29.06 35.278c0-1.651 1.167-2.99 2.606-2.99 1.439 0 2.606 1.339 2.606 2.99 0 1.65-1.167 3.728-2.606 3.728-1.439 0-2.606-2.081-2.606-3.728Z"
        fill="#C3C3F6"
      />
      <path
        d="m32.638 36.302.184-.018c0-.02-.224-1.97-2.034-2.017v.184c1.645.044 1.847 1.83 1.85 1.851Z"
        fill="#120283"
      />
      <path
        d="M30.852 36.025c.307-.318.622-.468.936-.453.475.028.797.441.8.445l.146-.112c-.014-.02-.374-.483-.933-.514-.377-.022-.734.149-1.081.514l.132.12Z"
        fill="#120283"
      />
      <path
        d="M50.983 46.76c-1.929 2.218-4.372 3.647-7.307 3.6-2.929.048-5.377-1.38-7.308-3.6a.195.195 0 0 0-.034-.04c-3.458-4.372-4.163-10.74-3.225-18.32.673-5.454 5.815-7.567 8.67-8.327a7.379 7.379 0 0 1 3.793 0c2.855.76 7.998 2.873 8.671 8.326.94 7.605.23 13.99-3.26 18.362Z"
        fill="#C3C3F6"
      />
      <path
        d="M47.62 36.014a.627.627 0 1 0 0-1.254.627.627 0 0 0 0 1.254ZM39.333 36.014a.627.627 0 1 0 0-1.254.627.627 0 0 0 0 1.254ZM50.97 30.173s-1.505.062-3.48.078c-1.977.015-2.486-.016-2.315-.817.17-.801 2.159-.787 3.396-.514 1.236.272 2.399 1.253 2.399 1.253ZM35.837 30.173s1.505.062 3.482.078c1.976.015 2.485-.016 2.314-.817-.171-.801-2.159-.787-3.396-.514-1.236.272-2.4 1.253-2.4 1.253ZM43.255 39.79c-.226 0-.448-.037-.572-.152a.334.334 0 0 1-.097-.313c.09-.576.425-2.862.429-2.885l.182.027c0 .023-.339 2.314-.43 2.886a.155.155 0 0 0 .042.15c.171.16.772.1 1.106.023l.041.18c-.23.05-.465.079-.7.083ZM43.886 41.137a3.29 3.29 0 0 1-.67-.06.102.102 0 0 1-.075-.13.103.103 0 0 1 .122-.077c.094.022 2.315.505 3.472-1.596a.105.105 0 0 1 .061-.05.105.105 0 0 1 .079.009.105.105 0 0 1 .04.14c-.83 1.514-2.21 1.764-3.03 1.764ZM45.3 41.571a.103.103 0 0 1-.02-.204c.155-.03.304-.085.44-.165a.102.102 0 0 1 .14.038.101.101 0 0 1-.036.14 1.581 1.581 0 0 1-.504.189l-.02.002ZM53.56 25.096l.688 10.286.742-3.472s2.208-4.598-1.43-6.814ZM33.791 23.899l-.97 11.485-.46-3.471s-2.208-4.6 1.43-8.014Z"
        fill="#120283"
      />
      <path
        d="M57.067 61.482s-3.96 6.448-13.827 6.348c-9.867-.1-14.256-6.09-14.256-6.09a25.72 25.72 0 0 0 2.692-2.24c1.39-1.315 2.972-3.1 3.857-5.056 0 0 .353-.403 2.757.25 2.404.651 5.088 1.393 8.769.752 3.68-.642 3.908-.753 4.16-.552.207.167 1.602 3.177 4.133 5.364.529.464 1.103.874 1.715 1.224Z"
        fill="#fff"
      />
      <path
        d="m50.642 115.225-9.45 7.893-4.93-3.407-3.322-2.3-1.264-.873s.192-1.827 1.382-7.577c.342-1.655.772-3.635 1.295-5.991.283-1.263.596-2.634.939-4.115.428-1.851.855-3.88 1.27-6.007.369-1.877.73-3.83 1.078-5.806.572-3.241 1.11-6.539 1.596-9.643a677.45 677.45 0 0 0 1.569-10.608c.489-3.487.771-5.71.771-5.71h3.215l.257 2.353.437 4.043.489 4.529.834 7.728.489 4.525.834 7.733.489 4.52.835 7.738.488 4.517.699 6.458Z"
        fill="#120283"
      />
      <path
        d="M45.049 63.427a139.288 139.288 0 0 1-4.243 3.357c.489-3.487.772-5.71.772-5.71h3.214l.257 2.353Z"
        fill="#000"
      />
      <path
        d="M39.96 60.698s2.593 2.144 3.177 2.242c.584.098 3.857-3.12 3.857-3.12l-1.964-3.508h-4.232l-.838 4.386Z"
        fill="#343493"
      />
      <path
        d="M55.349 60.258c-3.291 1.692-7.18 3.618-7.728 3.57-.974-.09-4.483-6.784-4.483-6.784s-3.6 6.795-4.874 6.783c-1.382-.011-4.114-2.54-6.588-4.326 1.39-1.316 2.972-3.101 3.857-5.057 0 0 .353-.403 2.757.25 2.404.651 5.088 1.393 8.769.752 3.68-.642 3.908-.753 4.16-.552.205.167 1.6 3.177 4.13 5.364Z"
        fill="#fff"
      />
      <path
        d="m7.356 119.232 11.141-42.803-9.195 43.814-1.946-1.011ZM68.221 121.388c2.36-21.215-2.36-42.986-2.36-42.986l9.34 39.184a53.805 53.805 0 0 1-6.98 3.802Z"
        fill="#E5E5E5"
      />
      <path
        d="m45.974 72-6.74 5.393c.307-1.969.59-3.857.85-5.617l5.4-4.305.49 4.528ZM47.298 84.252l-10.736 8.595c.369-1.877.73-3.831 1.077-5.806l9.17-7.313.489 4.524Z"
        fill="#343493"
      />
      <path
        d="M38.197 63.992c-.257 0-.977-.278-3.532-2.096-1.558-1.108-3.062-2.268-3.078-2.28l.18-.231c2.84 2.186 6.025 4.4 6.438 4.31.397-.205 3.163-4.243 4.811-6.732l.14-.211.112.226c.01.017.9 1.782 1.892 3.488 1.896 3.266 2.37 3.235 2.418 3.22.9-.27 7.64-3.527 7.708-3.56l.128.258c-.279.135-6.825 3.3-7.75 3.577-.206.063-.69.207-2.757-3.353a77.48 77.48 0 0 1-1.784-3.28c-.823 1.24-4.226 6.336-4.79 6.624a.257.257 0 0 1-.136.04Z"
        fill="#E9E9E9"
      />
      <path
        d="M84.653 108.318a23.328 23.328 0 0 1-1.591 2.294c.005-3.155.048-6.534.128-10.137.657-29.237-23.723-38.171-23.723-38.171 4.925 1.85 16.123 6.917 21.02 16.146 2.028 3.82 3.134 9.312 3.692 15.026.504 5.12.57 10.417.474 14.842Z"
        fill="#DFDFF4"
      />
      <path
        d="M54.908 29.35c-13.328 1.968-17.615-5.787-17.615-5.787-1.028 5.921-4.47 7.458-4.47 7.458s-1.05-3.327-1.157-5.915c-.108-2.588 4.896-7.092 10.914-7.75 6.019-.658 11.524 3.947 11.524 3.947l.7 7.255c-6.255 1.443-12.786-2.211-12.786-2.211 4.572 3.167 10.781 2.937 12.837 2.755l.053.247Z"
        fill="#120283"
      />
    </g>
  </svg>
)

export default SvgAvatar3
